import React from 'react'
import { Text } from 'components/Typography'
import { CheckboxProps } from 'components/Checkbox'
import { Box } from 'components/Layout'
import { COLOR } from 'theme'

interface Props {
  label?: string
  value: string[]
  onChange?: (value: string[]) => void
  children: React.ReactElement<CheckboxProps>[]
  errorMessage?: string
}

const CheckboxGroup: React.FC<Props> = ({ label, value, errorMessage, onChange, children }) => {
  const handleCheckboxChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name } = event.target
    if (name) {
      if (onChange) {
        onChange(event.target.checked ? [...value, name] : value.filter((val) => val !== name))
      }
    }
  }

  return (
    <Box display="grid" gridRowGap="0.5rem">
      <Text fontSize="xs" color={COLOR.grayDark} fontWeight={500}>
        {label}
      </Text>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          onChange: handleCheckboxChange,
          checked: !!child.props.name && value.includes(child.props.name),
        })
      )}
      {errorMessage && <Text color={COLOR.danger}>{errorMessage}</Text>}
    </Box>
  )
}

export { CheckboxGroup }
